<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Quick Assessment</span>
        <span class="font-weight-light" style="margin-left: 20px;"><span style="font-size: small">from</span> Freelance Developer Coach</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        href="https://www.FreelanceDeveloperCoach.com"
        target="_blank"
      >
        <span class="mr-2">Visit FDC</span>
      </v-btn>
    </v-toolbar>

    <v-content>
      <BasicSurvey/>
    </v-content>
  </v-app>
</template>

<script>
import BasicSurvey from './components/Basic'

export default {
  name: 'App',
  components: {
      BasicSurvey
  },
  data () {
    return {
      //
    }
  }
}
</script>
